import client from './client'

export interface NotificationActor {
  id: string
  name: string
  initials: string | null
  color: string | null
}

export interface AppNotification {
  id: string
  /** Klíč typu, např. `plan.assigned`, `task.assigned`, `hours.missing` */
  type: string
  title: string
  body: string | null
  /** Cesta ve frontendu, kam notifikace vede (např. `/attendance?date=2026-10-07`) */
  link: string | null
  entity_type: string | null
  entity_id: string | null
  actor: NotificationActor | null
  created_at: string
  read_at: string | null
}

export interface NotificationPage {
  items: AppNotification[]
  pagination: { total: number; page: number; per_page: number; total_pages: number }
  unread_count: number
}

export type NotificationFilter = 'all' | 'unread'

export async function getNotifications(params: { page: number; per_page: number; filter: NotificationFilter }): Promise<NotificationPage> {
  const r = await client.get('/notifications', { params: { page: params.page, per_page: params.per_page, filter: params.filter === 'unread' ? 'unread' : undefined } })
  return r.data.data
}

export async function getUnreadCount(): Promise<number> {
  const r = await client.get('/notifications/unread-count')
  return r.data.data.count as number
}

export async function markNotificationRead(id: string): Promise<{ unread_count: number }> {
  const r = await client.post(`/notifications/${id}/read`)
  return r.data.data
}

export async function markAllNotificationsRead(): Promise<void> {
  await client.post('/notifications/read-all')
}

// --- Administrace → Notifikace (kanály doručení) ---

export interface NotificationTypeInfo {
  key: string
  group: string
  label: string
  description: string
  default_app: boolean
  default_email: boolean
}

export type NotificationChannelMap = Record<string, { app: boolean; email: boolean }>

export async function getNotificationChannels(): Promise<{ types: NotificationTypeInfo[]; channels: NotificationChannelMap }> {
  const r = await client.get('/notifications/channels')
  return r.data.data
}

export async function saveNotificationChannels(channels: NotificationChannelMap): Promise<{ types: NotificationTypeInfo[]; channels: NotificationChannelMap }> {
  const r = await client.put('/notifications/channels', { channels })
  return r.data.data
}

/** Klíče react-query — sdílené zvonečkem, stránkou /notifications a invalidací. */
export const NOTIFICATION_KEYS = {
  all: ['notifications'] as const,
  unread: ['notifications', 'unread-count'] as const,
  list: (filter: NotificationFilter, page: number, perPage: number) => ['notifications', 'list', filter, page, perPage] as const,
}
